import { TransferRecordIdentityKey, TransferRecordIdentityKeyValue } from '../dtos';

export class TransferRecordIdentityBuilder {
	private identity: TransferRecordIdentityKey;

	public constructor() {
		this.identity = new TransferRecordIdentityKey();
		this.identity.PrimaryKeys = [];
	}

	public setTableName(tableName: string): TransferRecordIdentityBuilder {
		this.identity.TableName = tableName;
		return this;
	}

	public addPrimaryKey(pk: TransferRecordIdentityKeyValue): TransferRecordIdentityBuilder {
		this.identity.PrimaryKeys.push(pk);
		return this;
	}

	public build(): TransferRecordIdentityKey {
		if (!this.identity.TableName) {
			throw new Error('Please provide TableName for creating a TransferRecordIdentityKey');
		}

		if (!this.identity.PrimaryKeys || this.identity.PrimaryKeys.length === 0) {
			throw new Error('Please provide at least one primary key for TransferRecordIdentityKey');
		}

		return this.identity;
	}
}
